import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { MisAPI } from "../../../constants/API";
import { commonHeaders } from "../../../constants/HeadersAPI";
import { defaultSuccessMessage } from "../../../constants/alertText";
import { AlertContext } from "../../../context/AlertProvider";
import { AlertType } from "../../../types/enums";
import {
  MisConnectionDto,
  MisConnectionRequest,
} from "../../../types/Mis/MisTypes";

export const usePutMisConnection = (branchId: number | null) => {
  const queryClient = useQueryClient();
  const context = useContext(AlertContext);
  return useMutation(
    (payload: MisConnectionRequest) =>
      axios.put<MisConnectionDto>(
        MisAPI.updateConnection(branchId!),
        payload,
        commonHeaders(),
      ),
    {
      onSuccess: () => {
        queryClient
          .invalidateQueries(["misConnection", branchId])
          .then(() =>
            queryClient.invalidateQueries(["misQueueSettings"]),
          )
          .then(() =>
            context?.setAlert({
              type: AlertType.Success,
              message: defaultSuccessMessage,
            }),
          );
      },
    },
  );
};
